<template>
  <div>

    <el-card>

      <el-date-picker
        popper-class="custom-date-picker"
        size="mini"
        v-model="period"
        style="margin-bottom: 20px;"
        prefix-icon="el-icon-date"
        type="daterange"
        align="center"
        format="d MMM yy"
        value-format="timestamp"
        range-separator=""
        start-placeholder="Start date"
        end-placeholder="End date"
        @change="setFilter($event)"
        :picker-options="pickerOptions">
      </el-date-picker>

      <!--Table header-->
      <el-table
        size="mini"
        border
        :show-header="false"
        :data="listHeader"
        style="width: 100%; margin-bottom: -1px;">
        <el-table-column
          header-align="center">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="120"
          label="Action">
          <template slot-scope="scope">
            {{ scope.row.lastColumn }}
          </template>
        </el-table-column>
      </el-table>

      <el-table
        max-height="550"
        size="mini"
        :data="list"
        border
        style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          label="CR ID">
          <template slot-scope="scope">
            <strong @click="cellClickID(scope.row)" style="color: #409EFF; cursor: pointer;">{{scope.row.transactionNo}}</strong>
          </template>
        </el-table-column>
        <el-table-column
          prop="crDate"
          header-align="center"
          align="center"
          label="Date">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="right"
          label="Owing">
          <template slot-scope="scope">
            {{ scope.row.amountOwing > 0 ? formatPrice(scope.row.amountOwing) : null }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="right"
          label="Received">
          <template slot-scope="scope">
            {{ scope.row.amountReceived > 0 ? formatPrice(scope.row.amountReceived) : null }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="120"
          label="Action">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button size="mini"  type="primary">
                Action <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="scope.row.isUnderPayment" disabled>Request Payment</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.isUnderPayment" disabled>Write Down to Discounts</el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.isUnderPayment" disabled>Apply to Sale</el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.isUnderPayment" disabled>Give Refund</el-dropdown-item>
                <el-dropdown-item divided disabled>Create General Journal Entry</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <infinite-loading
            v-if="pagesCount > 1"
            slot="append"
            @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </el-table>

    </el-card>

  </div>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import moment from 'moment'
  import axios from 'axios'

  export default {
    name: 'Liquidations',
    props: ['selectedRow'],
    components: {
      InfiniteLoading,
    },
    data() {
      return {
        moment: moment,
        page: 1,
        pagesCount: 1,
        listHeader: [{
          title: 'Total Revenue',
          underPMTSum: 0,
          overPMTSum: 0,
          lastColumn: '0 Cr'
        }],
        list: [],

        period: null,
        pickerOptions: {
          shortcuts: [{
            text: 'This month',
            onClick(picker) {
              const end = moment().endOf('month');
              const start = moment().startOf('month');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(1, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(3, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial quarter',
            onClick(picker) {
              const end = moment().endOf('quarter');
              const start = moment().startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial quarter',
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial year',
            onClick(picker) {
              const end = moment().endOf('year');
              const start = moment().startOf('year');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial year',
            onClick(picker) {
              const end = moment().endOf('year').subtract(1, 'year');
              const start = moment().startOf('year').subtract(1, 'year');
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    methods: {
      openTab() {
        this.page = 1
        this.pagesCount = 1
        this.period = null
        this.loadList()
      },
      async loadList(isPagination) {
        let copiedArray = []
        if (isPagination) copiedArray = JSON.parse(JSON.stringify(this.list))
        let startDate = !this.period ? null : moment(this.period[0]).format('YYYY-MM-DD HH:mm:ss.sss')
        let endDate = !this.period ? null : moment(this.period[1]).format('YYYY-MM-DD HH:mm:ss.sss')

        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        axios.get(`/api/v1/cashReceipt/listByClientId?clientId=${this.selectedRow.vendorId}&page=${this.page}&startDate=${startDate}&endDate=${endDate}&type=cashReceipts`)
          .then(response => {
            this.listHeader[0].lastColumn = ''
            if (response.data.list.balance.total < 0) {
              this.listHeader[0].lastColumn = `(-) ${response.data.list.balance.total * -1} Cr`
            } else {
              this.listHeader[0].lastColumn = `${response.data.list.balance.total} Cr`
            }

            this.list = [...copiedArray, ...response.data.list.rows]
            this.pagesCount = response.data.list.page
            this.listHeader[0].underPMTSum = this.listHeader[0].overPMTSum = 0
            this.list.forEach((item) => {
              item.isUnderPayment = item.balanceOwing > 0 ? true : false
              item.crDate = item.crDate ? moment(item.crDate).format("D MMM YYYY") : ''
              if (item.balanceOwing > 0) {
                this.listHeader[0].underPMTSum += item.clientUnderPayment
              } else {
                this.listHeader[0].overPMTSum += item.clientOverPayment
              }
            })
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          })
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      async infiniteHandler($state) {
        try {
          if (this.page < this.pagesCount) {
            this.page += 1
            await this.loadList(true)
            $state.loaded()
          } else {
            $state.complete()
          }
        } catch (err) {
          console.log(err)
        }
      },
      cellClickID(row) {
        this.$router.push(`/cash-receipts/${row.id}?companyId=${this.$route.query.companyId}`)
      },
      setFilter(event) {
        this.page = 1
        this.pagesCount = 1
        this.loadList()
      }
    },
  }
</script>

<style lang="scss" scoped>
/deep/.el-table__body-wrapper {
  overflow-y: auto;
}

/deep/.el-range-separator{
  position:relative;
  &::before{
    color: #C0C4CC;
    font-family: "element-icons";
    position:absolute;
    content: "\E78E";
    left:5px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
